import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Constants } from './app-level-constants';
import { ApiCommunicationService } from './services/api-communication.service';
import { EncryptionService } from './services/encryption.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'tml-pl';
  constants = Constants;
  constructor(
    private readonly apiService: ApiCommunicationService,
    private readonly encryption: EncryptionService
  ) {}

  ngOnInit(): void {
    try {
      (window as any).getCodeFromAngular = () => {
        return this.apiService.getCredentials();
      };
    } catch (error) {
      console.log('Error', error);
    }
    try {
      (window as any).setCredentialsFromAngular = (salt: string) => {
        return this.apiService.setCredsLogin(salt);
      };
    } catch (error) {
      console.log('Error', error);
    }
    try {
      (window as any).encryptRequestPayload = async (data: any): Promise<string> => {
        return this.encryption.encryptionMFA(data);
      };
    } catch (error) {
      console.log('Error', error);
    }
    try {
      (window as any).decryptResponse = async (data: any): Promise<string> => {
        return this.encryption.decryptMessage(data);
      };
    } catch (error) {
      console.log('Error', error);
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    if (!this.constants.DEVTOOLS) {
      event.preventDefault();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.constants.DEVTOOLS) {
      return;
    }
    const key = event.key;

    if (key === 'F12') {
      event.preventDefault();
    }

    if (event.ctrlKey && event.shiftKey && key.toLowerCase() === 'i') {
      event.preventDefault();
    }

    if (event.ctrlKey && event.shiftKey && key.toLowerCase() === 'j') {
      event.preventDefault();
    }

    if (event.ctrlKey && key.toLowerCase() === 'u') {
      event.preventDefault();
    }
  }
}
